<style>
body {
    background: #FFFFFF;
}

.lead-container-fluid {
    padding: 0;
    margin: 0;
}

.lead-top-box {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 10px;
}

.lead-top-box > .pointexpress {
    position: absolute;
    width: 134px;
    height: 81px;
    left: 10px;
    top: 10px;
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 35px 35px;
}

.pointexpress-top-bg {
    background: linear-gradient(90.55deg, #951E00 31.87%, #FF8F3E 99.52%);
}

.theletter-top-bg {
    background: linear-gradient(90.44deg, #FFC947 -3.65%, #FF5D3A -3.65%, #FF3A32 108.25%);
}

.lead-top-box > .theletter {
    position: absolute;
    width: 134px;
    height: 134px;
    left: 10px;
    top: 10px;
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 30px;
}

.lead-top-box > h1 {
    font-family: 'Kanit';
    font-style: normal;
    font-size: 36px;
    color: #FFFFFF;
    position: relative;
    margin-left: 190px;
    text-align: center;
    font-weight: 500;
}

.lead-top-box > h2 {
    font-family: 'Kanit';
    font-style: normal;
    font-size: 24px;
    color: #FFFFFF;
    position: relative;
    margin-left:190px;
    font-weight: 300;
}

.lead-highlight {
    color: yellow;
}

.lead-group-left {
    width: 60%;
    height:972px;
    background-color: #000; /*Default bg, similar to the background's base color*/
    background-image: url("/img/bg-lead-sale/01.jpg");
    background-position: right bottom; /*Positioning*/
    background-repeat: no-repeat; /*Prevent showing multiple background images*/
    background-size: cover;
    float:left;
    padding: 10px;
}

.lead-group-left > .text-1 {
    font-family: 'Kanit';
    font-style: normal;
    font-size: 36px;
    font-weight: 500;
    margin:35px 35px;
}

.lead-group-left > .text-2 {
    font-family: 'Kanit';
    font-style: normal;
    font-size: 36px;
    font-weight: 500;
    margin:-35px 35px;
}

.lead-group-left > .text-bg {
    width: 395px;
    height: 71px;
    margin: 80px -10px;
    border-radius: 0px 50px 50px 0px;
}

.pointexpress-text-bg {
    background: #961E01;
}

.theletter-text-bg {
    background: #EA3224;
}

.lead-group-left > .text-bg > p {
    font-family: 'Kanit';
    font-style: normal;
    font-size: 28px;
    color: #FFFFFF;
    margin-left: 35px;
    padding-top: 15px;
}

.lead-group-left > .detail {
    margin: -30px 35px;
    font-family: 'Kanit';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    color: #404041;
    align-items: center;
}

.color-blue {
    color: #00A8E8;
}

.lead-group-right {
    width: 40%;
    height:972px;
    background: #FFFFFF;
    border-radius: 4px;
    padding: 52px 72px;
    float:left;
}

.lead-group-right > h3 {
    font-family: 'Kanit';
    font-style: normal;
    font-size: 24px;
}

.lead-group-right > p {
    font-family: 'Kanit';
    font-style: normal;
    font-size: 14px;
    color: #828282;
}

.lead-label {
    font-family: 'Kanit';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    display: flex;
}

.lead-input {
    font-family: 'Kanit';
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
}

.lead-input > span {
    margin-right:35px;
}

@media only screen and (max-width: 960px) {
    .lead-group-left,.lead-group-right {
        width:50%;
    }
    .lead-group-left > .text-2 {
        font-size:22px;
    }

    .lead-group-left > .detail > p {
      font-size:18px;
    }
}

@media only screen and (max-width: 670px) {
  .lead-group-right {
      width:100%;
  }

  .lead-group-left,.lead-group-right {
      width:100%;
      position: relative;
      left:0;
      height:800px;
  }

  .lead-group-right {
      height:auto;
  }

  .lead-group-left > .text-1 {
      margin: 20px 35px;
  }

  .lead-group-left > .text-bg {
      margin:50px -10px;
  }


  .lead-top-box > img {
      display: none;
  }


  .lead-top-box > h1 {
    font-size: 30px;
    margin-left:10px;
  }

 .lead-top-box > h2 {
    font-size: 20px;
    margin-left:10px;
  }

  .lead-group-left > .detail > p {
      font-size:18px;
    }


}


</style>
<template>
<!-- Page content -->

<div class="container-fluid lead-container-fluid">
    <BlockUI v-if="busy">
                    <div class="loader"></div>
                </BlockUI>
<div class="lead-top-box" :class="$THEME.name + '-top-bg'">
    <h1>{{ $THEME.headerText.title || '' }}</h1>
    <img src="/img/brand/logo.png" :class="$THEME.name"/>
    <h2>ระบบแฟรนไชส์ {{ $THEME.webTitle || '-' }} ได้ถูกระงับการให้บริการจากผู้ให้บริการ <span class="lead-highlight">ตั้งแต่วันที่ 1 มีนาคม 2565</span> หากลูกค้าท่านใดสนใจใช้บริการ ร้านไปรษณีย์เอกชนสามารถกรอกข้อมูลด้านล่างเพื่อให้ทีมงาน ของเราติดต่อกลับไป</h2>
</div>
<div class="lead-group-left">
<p class="text-1" :style="{color:$THEME.primaryColor}">ธุรกิจยอดฮิตยุคนี้</p>
<p class="text-2">ต้องร้านรับส่งพัสดุ <span class="color-blue">SHIPPOP</span> เท่านั้น</p>
<div class="text-bg" :class="$THEME.name + '-text-bg'">
    <p class="text-3">สิ่งที่คุณจะได้จาก POPSHOP</p>
</div>
<div class="detail">
    <p><svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 0C5.8 0 0 5.8 0 13C0 20.2 5.8 26 13 26C20.2 26 26 20.2 26 13C26 11.602 25.812 10.207 25.312 8.906L23.688 10.5C23.888 11.3 24.001 12.102 24.001 13C24.001 19.102 19.103 24 13.001 24C6.899 24 2 19.102 2 13C2 6.898 6.898 2 13 2C16 2 18.695 3.195 20.594 5.094L22 3.688C19.7 1.386 16.5 0 13 0ZM24.281 4.281L13 15.563L8.719 11.281L7.281 12.719L12.281 17.719L13 18.406L13.719 17.719L25.719 5.719L24.281 4.281Z" fill="#009EFF"/>
    </svg>&nbsp;&nbsp;ราคาส่งพัสดุเริ่มต้น 1X บาท ส่งด่วนทั่วไทย!</p>
    <p><svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 0C5.8 0 0 5.8 0 13C0 20.2 5.8 26 13 26C20.2 26 26 20.2 26 13C26 11.602 25.812 10.207 25.312 8.906L23.688 10.5C23.888 11.3 24.001 12.102 24.001 13C24.001 19.102 19.103 24 13.001 24C6.899 24 2 19.102 2 13C2 6.898 6.898 2 13 2C16 2 18.695 3.195 20.594 5.094L22 3.688C19.7 1.386 16.5 0 13 0ZM24.281 4.281L13 15.563L8.719 11.281L7.281 12.719L12.281 17.719L13 18.406L13.719 17.719L25.719 5.719L24.281 4.281Z" fill="#009EFF"/>
    </svg>&nbsp;&nbsp;มีส่วนแบ่งรายได้ ได้รับกำไรสูงสุดถึง 70%</p>
    <p><svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 0C5.8 0 0 5.8 0 13C0 20.2 5.8 26 13 26C20.2 26 26 20.2 26 13C26 11.602 25.812 10.207 25.312 8.906L23.688 10.5C23.888 11.3 24.001 12.102 24.001 13C24.001 19.102 19.103 24 13.001 24C6.899 24 2 19.102 2 13C2 6.898 6.898 2 13 2C16 2 18.695 3.195 20.594 5.094L22 3.688C19.7 1.386 16.5 0 13 0ZM24.281 4.281L13 15.563L8.719 11.281L7.281 12.719L12.281 17.719L13 18.406L13.719 17.719L25.719 5.719L24.281 4.281Z" fill="#009EFF"/>
    </svg>&nbsp;&nbsp;ขนส่งชั้นนำที่มารวมอยู่ในร้านเดียวกัน ใช้งานได้จริงทุกขนส่ง</p>
    <p><svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 0C5.8 0 0 5.8 0 13C0 20.2 5.8 26 13 26C20.2 26 26 20.2 26 13C26 11.602 25.812 10.207 25.312 8.906L23.688 10.5C23.888 11.3 24.001 12.102 24.001 13C24.001 19.102 19.103 24 13.001 24C6.899 24 2 19.102 2 13C2 6.898 6.898 2 13 2C16 2 18.695 3.195 20.594 5.094L22 3.688C19.7 1.386 16.5 0 13 0ZM24.281 4.281L13 15.563L8.719 11.281L7.281 12.719L12.281 17.719L13 18.406L13.719 17.719L25.719 5.719L24.281 4.281Z" fill="#009EFF"/>
    </svg>&nbsp;&nbsp;บริการดูแลหลังบ้านโดย Customer Service ที่จะช่วยให้คุณทำงานได้ สะดวกยิ่งขึ้น</p>
    <p><svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 0C5.8 0 0 5.8 0 13C0 20.2 5.8 26 13 26C20.2 26 26 20.2 26 13C26 11.602 25.812 10.207 25.312 8.906L23.688 10.5C23.888 11.3 24.001 12.102 24.001 13C24.001 19.102 19.103 24 13.001 24C6.899 24 2 19.102 2 13C2 6.898 6.898 2 13 2C16 2 18.695 3.195 20.594 5.094L22 3.688C19.7 1.386 16.5 0 13 0ZM24.281 4.281L13 15.563L8.719 11.281L7.281 12.719L12.281 17.719L13 18.406L13.719 17.719L25.719 5.719L24.281 4.281Z" fill="#009EFF"/>
    </svg>&nbsp;&nbsp;รับค่าคอมมิชชั่นเพิ่มเติมมากขึ้น จากการส่งแบบเก็บเงินปลายทาง (COD)</p>
</div>
</div>
<div class="lead-group-right">
    <h3 class="color-blue">กรอกข้อมูลเพื่อรับสิทธิ์ในการเปิดร้าน</h3>
    <p>โปรดกรอกข้อมูลให้ครบถ้วนและถูกต้อง ทีมงานจะติดต่อกลับหาคุณโดยเร็วที่สุด</p>
    <form @submit.prevent="handleSubmit">
                        <div class="form-group lead-input" :class="{ 'is-invalid': submitted && $v.frontArea.$error }">
                            <label class="lead-label">คุณมีพื้นที่หน้าร้านใช่หรือไม่</label>
                            <span><input type="radio" v-model="frontArea" value="มี" tab-index="0" required>&nbsp;&nbsp;มี</span>
                            <span><input type="radio" v-model="frontArea" value="ไม่มี">&nbsp;&nbsp;ไม่มี</span>
                            <!-- Vuelidate -->
                            <div v-if="submitted && $v.frontArea.$error" class="invalid-feedback position-absolute">
                                <span v-if="!$v.frontArea.required">กรุณาเลือก</span>
                            </div>
                        </div>
                        <div class="form-group lead-input" :class="{ 'is-invalid': submitted && $v.haveComputer.$error }">
                            <label class="lead-label">คุณมีคอมพิวเตอร์ส่วนตัวหรือไม่</label>
                            <span><input type="radio" v-model="haveComputer" value="มี">&nbsp;&nbsp;มี</span>
                            <span><input type="radio" v-model="haveComputer" value="ไม่มี">&nbsp;&nbsp;ไม่มี</span>
                            <!-- Vuelidate -->
                            <div v-if="submitted && $v.haveComputer.$error" class="invalid-feedback position-absolute">
                                <span v-if="!$v.haveComputer.required">กรุณาเลือก</span>
                            </div>
                        </div>
                        <div class="form-group lead-input" :class="{ 'is-invalid': submitted && $v.skillComputer.$error }">
                            <label class="lead-label">ความชำนาญในการใช้คอมพิวเตอร์ของคุณ</label>
                            <span><input type="radio" v-model="skillComputer" value="มาก">&nbsp;&nbsp;มาก</span>
                           <span><input type="radio" v-model="skillComputer" value="ปานกลาง">&nbsp;&nbsp;ปานกลาง</span>
                            <span><input type="radio" v-model="skillComputer" value="ภายใน 1 เดือน">&nbsp;&nbsp;ภายใน 1 เดือน</span>
                            <!-- Vuelidate -->
                            <div v-if="submitted && $v.skillComputer.$error" class="invalid-feedback position-absolute">
                                <span v-if="!$v.skillComputer.required">กรุณาเลือก</span>
                            </div>
                        </div>

                        <div class="form-group lead-input" :class="{ 'is-invalid': submitted && $v.readyOpen.$error }">
                            <label class="lead-label">พร้อมเปิดให้บริการเมื่อใด</label>
                            <span><input type="radio" v-model="readyOpen" value="ทันที">&nbsp;&nbsp;ทันที</span>
                           <span><input type="radio" v-model="readyOpen" value="ภายใน 1 สัปดาห์">&nbsp;&nbsp;ภายใน 1 สัปดาห์</span>
                            <span><input type="radio" v-model="readyOpen" value="น้อย">&nbsp;&nbsp;น้อย</span>

                            <!-- Vuelidate -->
                            <div v-if="submitted && $v.readyOpen.$error" class="invalid-feedback position-absolute">
                                <span v-if="!$v.readyOpen.required">กรุณาเลือก</span>
                            </div>
                        </div>


                        <div class="form-group lead-input">
                            <label class="lead-label">คุณต้องการเปิด SHIPPOP SHOP ที่จังหวัดใด</label>
                            <select v-model="provinceShop" class="form-control" @change="selectAmphur(provinceShop)" :class="{ 'is-invalid': submitted && $v.provinceShop.$error }">
                                <option value="null">กรุณาเลือกจังหวัด</option>
                                <option v-for="item in province" :value="item.name_th">{{item.name_th}}</option>
                            </select>
                            <!-- Vuelidate -->
                            <div v-if="submitted && $v.provinceShop.$error" class="invalid-feedback position-absolute">
                                <span v-if="!$v.provinceShop.required">กรุณาเลือกจังหวัด</span>
                            </div>
                        </div>

                        <div class="form-group lead-input">
                            <label class="lead-label">อำเภอ/เขต</label>
                            <select v-model="districtShop" class="form-control" :class="{ 'is-invalid': submitted && $v.districtShop.$error }">
                                <option value="null">กรุณาเลือก อำเภอ/เขต</option>
                                <option v-for="item in amphur" :value="item.name_th">{{item.name_th}}</option>
                            </select>

                            <!-- Vuelidate -->
                            <div v-if="submitted && $v.districtShop.$error" class="invalid-feedback position-absolute">
                                <span v-if="!$v.districtShop.required">กรุณาเลือก อำเภอ/เขต</span>
                            </div>
                        </div>

                        <div class="form-group lead-input">
                            <label class="lead-label">ชื่อ-สกุล</label>
                            <input class="form-control" id="fullName" :class="{ 'is-invalid': submitted && $v.fullName.$error }" v-model="fullName"  />

                            <!-- Vuelidate -->
                            <div v-if="submitted && $v.fullName.$error" class="invalid-feedback position-absolute">
                                <span v-if="!$v.fullName.required">กรุณากรอกข้อมูล</span>
                            </div>
                        </div>

                        <div class="form-group lead-input">
                            <label class="lead-label">เบอร์โทรฯ</label>
                            <input class="form-control" :class="{ 'is-invalid': submitted && $v.phone.$error }" id="phone" @keypress="onlyNumber" maxlength="10" v-model="phone"  />

                            <!-- Vuelidate -->
                            <div v-if="submitted && $v.phone.$error" class="invalid-feedback position-absolute">
                                <span v-if="!$v.phone.required">กรุณากรอกข้อมูล</span>
                            </div>
                        </div>

                        <div class="text-right">
                            <button type="submit" class="my-4 btn btn-primary btn-icon btn-block kanit">ส่งข้อมูล</button>
                        </div>
                    </form>
</div>

    <ModalNotification :notiShop="noti" />
</div>
</template>

<script>
import validatePop from "../plugins/validatePop.js"
import ModalNotification from '@/components/custom/ModalNotification'
import {
    required
} from "vuelidate/lib/validators";

const API_URL = process.env.VUE_APP_API;
const API_SHEET = process.env.VUE_APP_SHEET || 'https://script.google.com/macros/s/AKfycbwWYTJRORRFXA2syUtiUEeojVS-akNVVMnTixSYIgL_a49l6yEzD3z00iVTkoCLHYob/exec?action=add&callback=?';

export default {
    name: "login",
    components: {
        ModalNotification
    },
    data() {
        return {
            popVersion: process.env.VUE_APP_VERSION,
            email: null,
            password: null,
            submitted: false,
            busy: false,
            frontArea:null,
            readyOpen:null,
            haveComputer:null,
            skillComputer:null,
            provinceShop:null,
            districtShop:null,
            fullName:null,
            phone:null,
            noti: {
                show: false,
                type: "",
                created_by: "",
                role: "",
                date_noti: "",
                router: true
            },
            userLogin: "",
            jsonProvince:[],
            province: [],
            jsonAmphur:[],
            amphur:[]
        };
    },

    validations: {
        frontArea: {
            required
        },
        readyOpen: {
            required
        },
        haveComputer: {
            required
        },
        skillComputer: {
            required
        },
        provinceShop: {
            required
        },
        districtShop: {
            required
        },
        fullName: {
            required
        },
        phone: {
            required
        }
    },
    mounted() {
        const currentURL = window.location.href
        const httpPatt = /^http:\/\//ig
        if (httpPatt.test(currentURL) && !process.env.VUE_APP_HTTP) {
            window.location = currentURL.replace(httpPatt, 'https://')
        }

        this.$http.get('https://raw.githubusercontent.com/kongvut/thai-province-data/master/json/thai_provinces.json').then(response => {
            this.jsonProvince = this.province =  response.data['RECORDS'];

        });
        this.$http.get('https://raw.githubusercontent.com/kongvut/thai-province-data/master/json/thai_amphures.json').then(response => {
            this.jsonAmphur = response.data['RECORDS'];
        });

    },
    methods: {
        handleSubmit(e) {
            this.busy = true
            this.submitted = true;
            this.$v.$touch();
            console.log(this.$v.$invalid);
            if (this.$v.$invalid) {
                this.busy = false;
                return false;
            }
            e.preventDefault();

                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                var raw = JSON.stringify({
                        frontArea: this.frontArea,
                        readyOpen: this.readyOpen,
                        haveComputer: this.haveComputer,
                        skillComputer: this.skillComputer,
                        provinceShop: this.provinceShop,
                        districtShop: this.districtShop,
                        fullName: this.fullName,
                        phone: "'" + this.phone,
                        source: this.$THEME.name
                    });

                var requestOptions = {
                    method: 'POST',
                    headers: myHeaders,
                    body: raw,
                    mode:'no-cors',
                    redirect: "follow",
                };

                fetch(API_SHEET, requestOptions)
                .then(response => response.text())
                .then(result => {
                    this.$bvModal.msgBoxOk("บันทึกข้อมูลเรียบร้อย", {
                        title: "SUCCESS",
                        size: "sm",
                        buttonSize: "sm",
                        okVariant: "success",
                        okTitle: "Ok",
                        contentClass: "modal-success",
                        headerClass: "p-2 border-bottom-0",
                        footerClass: "p-2 border-top-0",
                        centered: true
                    });
                    this.busy = false;
                    this.clearForm();
                })
                .catch(error =>  this.showErrorModal("พบปัญหาการเชื่อมต่อ\n" + error));

        },
        onlyNumber ($event) {
   //console.log($event.keyCode); //keyCodes value
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                $event.preventDefault();
            }
        },
        clearForm() {
            this.submitted = false;
            this.frontArea = null;
            this.readyOpen = null;
            this.haveComputer = null;
            this.skillComputer = null;
            this.provinceShop = null;
            this.districtShop = null;
            this.fullName = null;
            this.phone = null;
        },
        checkStatusShop() {
            return new Promise((resolve) => {
                this.$http
                    .get(API_URL + "/shop/noti", {
                        headers: {
                            Token: localStorage.getItem("access_token")
                        }
                    })
                    .then(res => {
                        let checkError = validatePop(res)
                        if (!checkError.status) {
                            if (checkError.notices == "token is expired") {
                                this.$router.push("/logout")
                            }
                            this.showErrorModal(checkError.msg)
                            this.busy = false
                            return false
                        }
                        resolve(res)
                    })
                    .catch(() => {
                        this.showErrorModal("พบปัญหาการเชื่อมต่อ กรุณาติดต่อ...");
                    });
            });
        },
        selectAmphur(province) {
            var province_id = this.province.filter(item => item.name_th == province)[0].id || null;
            this.amphur = this.jsonAmphur.filter(item => item.province_id == province_id);
        },
        showErrorModal(msgBody) {
            this.$bvModal.msgBoxOk(msgBody, {
                title: "ERROR",
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: "ลองอีกครั้ง",
                contentClass: "modal-errors",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true
            });
        },
    }
};
</script>

<style>
</style>
